import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const Login = () => import('@/containers/login/Login')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Actuator = () => import('@/views/Actuator')
const MasterMerkBarang = () => import('@/views/master/merkbarang/MasterMerkBarang')
const InputMerkBarang = () => import('@/views/master/merkbarang/InputMerkBarang')
const DetailMerkBarang = () => import('@/views/master/merkbarang/DetailMerkBarang')
const EditMerkBarang = () => import('@/views/master/merkbarang/EditMerkBarang')
const KasMutasi = () => import('@/views/kasir/kasmutasi/KasMutasi')
const InputKasMutasi = () => import('@/views/kasir/kasmutasi/InputKasMutasi')
const InputKasMutasiHo = () => import('@/views/kasir/kasmutasi/InputKasMutasiHo')
const DetailKasMutasi = () => import('@/views/kasir/kasmutasi/DetailKasMutasi')
const TransaksiGadai = () => import('@/views/kasir/transaksigadai/TransaksiGadai')
const DetailTransaksiGadai = () => import('@/views/kasir/transaksigadai/DetailTransaksiGadai')
const KasMasuk = () => import('@/views/kasir/kasmasuk/KasMasuk')
const InputKasMasuk = () => import('@/views/kasir/kasmasuk/InputKasMasuk')
const KasKeluar = () => import('@/views/kasir/kaskeluar/KasKeluar')
const InputKasKeluar = () => import('@/views/kasir/kaskeluar/InputKasKeluar')
const DaftarGadai = () => import('@/views/gadai/DaftarGadai')
const DetailGadai = () => import('@/views/gadai/DetailGadai')
const DaftarBarangHilang = () => import('@/views/gadai/baranghilang/DaftarBarangHilang')
const DetailBarangHilang = () => import('@/views/gadai/baranghilang/DetailBarangHilang')
const DaftarPenarikan = () => import('@/views/gadai/daftarpenarikan/DaftarPenarikan')
const DetailPenarikan = () => import('@/views/gadai/daftarpenarikan/DetailPenarikan')
const SimulasiGadai = () => import('@/views/gadai/SimulasiGadai')
const PengajuanGadai = () => import('@/views/gadai/pengajuan-gadai/PengajuanGadai')
const InputGadaiElektronik = () => import('@/views/gadai/elektronik/InputElektronik')
const EditGadaiElektronik = () => import('@/views/gadai/elektronik/EditElektronik')
const EditStagingElektronik = () => import('@/views/gadai/elektronik/EditStagingElektronik')
const InputGadaiKendaraan = () => import('@/views/gadai/kendaraan/InputKendaraan')
const EditGadaiKendaraan = () => import('@/views/gadai/kendaraan/EditKendaraan')
const EditStagingKendaraan = () => import('@/views/gadai/kendaraan/EditStagingKendaraan')
const MasterAnggota = () => import('@/views/master/anggota/MasterAnggota')
const InputAnggota = () => import('@/views/master/anggota/InputAnggota')
const EditAnggota = () => import('@/views/master/anggota/EditAnggota')
const HistoryAnggota = () => import('@/views/master/anggota/HistoryDataAnggota')
const DetailAnggota = () => import('@/views/master/anggota/DetailAnggota')
const MasterTipeBarang = () => import('@/views/master/tipebarang/MasterTipeBarang')
const InputTipeBarang = () => import('@/views/master/tipebarang/InputTipeBarang')
const DetailTipeBarang = () => import('@/views/master/tipebarang/DetailTipeBarang')
const EditTipeBarang = () => import('@/views/master/tipebarang/EditTipeBarang')
const MasterJenisBarang = () => import('@/views/master/jenisbarang/MasterJenisBarang')
const InputJenisBarang = () => import('@/views/master/jenisbarang/InputJenisBarang')
const DetailJenisBarang = () => import('@/views/master/jenisbarang/DetailJenisBarang')
const EditJenisBarang = () => import('@/views/master/jenisbarang/EditJenisBarang')
const EditKondisiJenisBarang = () => import('@/views/master/jenisbarang/EditKondisiJenisBarang')
const MasterUserStaff = () => import('@/views/master/userstaff/MasterUserStaff')
const InputUserStaff = () => import('@/views/master/userstaff/InputUserStaff')
const DetailUserStaff = () => import('@/views/master/userstaff/DetailUserStaff')
const EditUserStaff = () => import('@/views/master/userstaff/EditUserStaff')
const MasterRole = () => import('@/views/master/role/MasterRole')
const InputRole = () => import('@/views/master/role/InputRole')
const DetailRole = () => import('@/views/master/role/DetailRole')
const EditRole = () => import('@/views/master/role/EditRole')
const MasterPromo = () => import('@/views/master/promo/MasterPromo')
const InputPromo = () => import('@/views/master/promo/InputPromo')
const DetailPromo = () => import('@/views/master/promo/DetailPromo')
const EditPromo = () => import('@/views/master/promo/EditPromo')
const MasterParameter = () => import('@/views/master/parameter/MasterParameter')
const MasterWilayah = () => import('@/views/master/wilayah/MasterWilayah')
const MasterAksesMenu = () => import('@/views/master/aksesmenu/MasterAksesMenu')
const BatchLelang = () => import('@/views/lelang/batchlelang/BatchLelang')
const InputBatchLelang = () => import('@/views/lelang/batchlelang/InputBatchLelang')
const DetailBatchLelang = () => import('@/views/lelang/batchlelang/DetailBatchLelang')
const DetailBatchLelangItem = () => import('@/views/lelang/batchlelang/DetailBatchLelangItem')
const PersiapanLelang = () => import('@/views/lelang/persiapanlelang/PersiapanLelang')
const DetailPersiapanLelang = () => import('@/views/lelang/persiapanlelang/DetailPersiapanLelang')
const PenjualanLelang = () => import('@/views/lelang/penjualanlelang/PenjualanLelang')
const BulkSetLelang = () => import('@/views/lelang/bulksetlelang/BulkSetLelang')
const KirimBalik = () => import('@/views/lelang/kirimbalik/KirimBalik')
const MasterCabang = () => import('@/views/master/cabang/Cabang')
const InputCabang = () => import('@/views/master/cabang/InputCabang')
const DetailCabang = () => import('@/views/master/cabang/DetailCabang')
const EditCabang = () => import('@/views/master/cabang/EditCabang')
const AksesLaporanEksekutif = () => import('@/views/akseslaporaneksekutif/AksesLaporanEksekutif')
const InformasiUmum = () => import('@/views/informasi/InformasiUmum')
const InputInformasiUmum = () => import('@/views/informasi/InputInformasiUmum')
const DetailInformasiUmum = () => import('@/views/informasi/DetailInformasiUmum')
const EditInformasiUmum = () => import('@/views/informasi/EditInformasiUmum')
const Pelunasan = () => import('@/views/pembayaran/Pelunasan')
const Perpanjangan = () => import('@/views/pembayaran/Perpanjangan')
const DetailPelunasan = () => import('@/views/pembayaran/DetailPelunasan')
const DetailPerpanjangan = () => import('@/views/pembayaran/DetailPerpanjangan')
const TransaksiPembayaran = () => import('@/views/kasir/transaksipembayaran/TransaksiPembayaran')
const DetailTransaksiPembayaran = () => import('@/views/kasir/transaksipembayaran/DetailTransaksiPembayaran')
const ApprovalBarangHilang = () => import('@/views/approval/baranghilang/ApprovalBarangHilang')
const DetailApprovalBarangHilang = () => import('@/views/approval/baranghilang/DetailApprovalBarangHilang')
const CekGadai = () => import('@/views/approval/cekgadai/CekGadai')
const DetailCekGadai = () => import('@/views/approval/cekgadai/DetailCekGadai')
const ApprovalEditGadai = () => import('@/views/approval/editgadai/ApprovalEditGadai')
const DetailApprovalEditGadai = () => import('@/views/approval/editgadai/DetailApprovalEditGadai')
const VoidPembayaran = () => import('@/views/approval/voidpembayaran/VoidPembayaran')
const DetailVoidPembayaran = () => import('@/views/approval/voidpembayaran/DetailVoidPembayaran')
const ApprovalKeringanan = () => import('@/views/approval/keringanan/ApprovalKeringanan')
const DetailKeringanan = () => import('@/views/approval/keringanan/DetailKeringanan')
const ApprovalKasKeluar = () => import('@/views/approval/kaskeluar/ApprovalKasKeluar')
const DetailApprovalKasKeluar = () => import('@/views/approval/kaskeluar/DetailApprovalKasKeluar')
const DaftarCekGadai = () => import('@/views/pusat/cekgadai/DaftarCekGadai')
const DetailDaftarCekGadai = () => import('@/views/pusat/cekgadai/DetailDaftarCekGadai')
const DaftarVoidGadai = () => import('@/views/pusat/voidgadai/DaftarVoidGadai')
const DaftarVoidPembayaran = () => import('@/views/pusat/voidpembayaran/DaftarVoidPembayaran')
const SuratBpkb = () => import('@/views/pusat/suratbpkb/SuratBpkb')
const InputSuratBpkb = () => import('@/views/pusat/suratbpkb/InputSuratBpkb')
const DetailSuratBpkb = () => import('@/views/pusat/suratbpkb/DetailSuratBpkb')
const DaftarPenarikanPusat = () => import('@/views/pusat/daftarpenarikan/DaftarPenarikan')
const DetailPenarikanPusat = () => import('@/views/pusat/daftarpenarikan/DetailPenarikan')
const SMS = () => import('@/views/pusat/sms/Sms')
const KirimSms = () => import('@/views/pusat/sms/KirimSms')
const MonitoringIp = () => import('@/views/pusat/monitoringip/MonitoringIp')
const DetailMonitoringIp = () => import('@/views/pusat/monitoringip/DetailMonitoringIp')
const DaftarEditGadai = () => import('@/views/pusat/daftareditgadai/DaftarEditGadai')
const DetailDaftarEditGadai = () => import('@/views/pusat/daftareditgadai/DetailDaftarEditGadai')
const InquiryFaktur = () => import('@/views/inquiry/inquiryfaktur/InquiryFaktur')
const DetailInquiryFaktur = () => import('@/views/inquiry/inquiryfaktur/DetailInquiryFaktur')
const HistoryGadai = () => import('@/views/inquiry/inquiryfaktur/HistoryDataGadai')
const TransaksiHarian = () => import('@/views/laporanhariancabang/TransaksiHarian')
const SerahTerimaGadai = () => import('@/views/laporanhariancabang/SerahTerimaGadai')
const SerahTerimaGadaiLunas = () => import('@/views/laporanhariancabang/SerahTerimaGadaiLunas')
const LaporanOmzet = () => import('@/views/laporaneksekutif/laporanomzet/LaporanOmzet')
const LaporanGadaiBaru = () => import('@/views/laporaneksekutif/laporangadaibaru/LaporanGadaiBaru')
const DetailLaporanGadaiBaru = () => import('@/views/laporaneksekutif/laporangadaibaru/DetailLaporanGadaiBaru')
const LaporanPemasukan = () => import('@/views/laporaneksekutif/laporanpemasukan/LaporanPemasukan')
const DetailLaporanPemasukan = () => import('@/views/laporaneksekutif/laporanpemasukan/DetailLaporanPemasukan')
const LaporanPembayaranEksekutif = () => import('@/views/laporaneksekutif/laporanpembayaran/LaporanPembayaran')
const DetailLaporanPembayaranEksekutif = () => import('@/views/laporaneksekutif/laporanpembayaran/DetailLaporanPembayaran')
const DaftarBpkbMacet = () => import('@/views/laporaneksekutif/laporanbpkbmacet/LaporanBpkbMacet')
const DetailDaftarBpkbMacet = () => import('@/views/laporaneksekutif/laporanbpkbmacet/DetailLaporanBpkbMacet')
const DaftarGadaiAktif = () => import('@/views/laporaneksekutif/daftargadaiaktif/DaftarGadaiAktif')
const DetailGadaiAktif = () => import('@/views/laporaneksekutif/daftargadaiaktif/DetailGadaiAktif')
const LaporanPenjualan = () => import('@/views/laporaneksekutif/laporanpenjualan/LaporanPenjualan')
const StokGudang = () => import('@/views/laporan/stokgudang/StokGudang')
const BukuBesar = () => import('@/views/laporan/LaporanBukuBesar')
const LaporanKasKeluar = () => import('@/views/laporan/LaporanKasKeluar')
const LaporanKasMasuk = () => import('@/views/laporan/LaporanKasMasuk')
const LaporanKasMutasi = () => import('@/views/laporan/LaporanKasMutasi')
const LaporanPembayaran = () => import('@/views/laporan/LaporanPembayaran')
const LaporanKasCabang = () => import('@/views/laporan/LaporanKasCabang')
const LaporanKembarImei = () => import('@/views/laporan/LaporanKembarImei')
const LaporanPelunasan = () => import('@/views/laporan/LaporanPelunasan')
const MasterTipePinjaman = () => import('@/views/master/tipepinjaman/MasterTipePinjaman')
const TambahTipePinjaman = () => import('@/views/master/tipepinjaman/TambahTipePinjaman')
const EditTipePinjaman = () => import('@/views/master/tipepinjaman/EditTipePinjaman')
const AtributJenisBarang = () => import('@/views/master/atribut-jenis-barang/AtributJenisBarang')
const TambahAtributJenisBarang = () => import('@/views/master/atribut-jenis-barang/TambahAtributJenisBarang')

Vue.use(Router)
const emptyPage = { component: { render(c) { return c('router-view') } } }

function configRoutes() {
    return [
        {
            path: '/actuator',
            name: 'Actuator',
            component: Actuator
        },
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            meta: { hideInBreadcrumb: true },
            component: DefaultContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'master',
                    name: 'Master',
                    redirect: '/master/jenis-barang',
                    ...emptyPage,
                    children: [
                        {
                            path: 'tipe-pinjaman',
                            name: 'Tipe Pinjaman',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterTipePinjaman
                                },
                                {
                                    path: 'tambah',
                                    name: 'Tambah',
                                    component: TambahTipePinjaman
                                },
                                {
                                    path: ':id/edit',
                                    name: 'Edit',
                                    component: EditTipePinjaman
                                },
                                {
                                    path: 'edit',
                                    name: 'EditLegacy',
                                    component: EditTipePinjaman
                                },

                            ]
                        },
                        {
                            path: 'jenis-barang',
                            name: 'Jenis Barang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterJenisBarang
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputJenisBarang
                                },
                                {
                                    path: 'edit-kondisi-bulk',
                                    name: 'Edit Kondisi Bulk',
                                    component: EditKondisiJenisBarang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailJenisBarang
                                        },
                                        {
                                            path: 'edit',
                                            name: 'Edit',
                                            component: EditJenisBarang
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'merk-barang',
                            name: 'Merk Barang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterMerkBarang
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputMerkBarang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailMerkBarang
                                        },
                                        {
                                            path: "edit",
                                            name: "Edit",
                                            component: EditMerkBarang
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'tipe-barang',
                            name: 'Tipe Barang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterTipeBarang
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputTipeBarang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailTipeBarang
                                        },
                                        {
                                            path: "edit",
                                            name: "Edit",
                                            component: EditTipeBarang
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'atribut-jenis-barang',
                            name: 'Atribut Jenis Barang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: AtributJenisBarang
                                },
                                {
                                    path: 'tambah',
                                    name: 'Tambah Atribut Jenis Barang',
                                    component: TambahAtributJenisBarang
                                },
                                {
                                    path: ':id/edit',
                                    name: 'Edit Atribut Jenis Barang',
                                    component: TambahAtributJenisBarang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Atribut Jenis Barang',
                                    component: TambahAtributJenisBarang
                                }
                            ]
                        },
                        {
                            path: 'cabang',
                            name: 'Cabang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterCabang
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputCabang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailCabang
                                        },
                                        {
                                            path: "edit",
                                            name: "Edit",
                                            component: EditCabang
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'anggota',
                            name: 'Anggota',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterAnggota
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputAnggota
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailAnggota
                                        },
                                        {
                                            path: "edit",
                                            name: "Edit",
                                            component: EditAnggota
                                        },
                                        {
                                            path: "detail-history",
                                            name: "History Data Anggota",
                                            component: HistoryAnggota
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'user-staff',
                            name: 'User Staff',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterUserStaff
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputUserStaff
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailUserStaff
                                        },
                                        {
                                            path: 'edit',
                                            name: 'Edit',
                                            component: EditUserStaff
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'role',
                            name: 'Role',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterRole
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputRole
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailRole
                                        },
                                        {
                                            path: 'edit',
                                            name: 'Edit',
                                            component: EditRole
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'promo',
                            name: 'Promo',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterPromo
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputPromo
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailPromo
                                        },
                                        {
                                            path: 'edit',
                                            name: 'Edit',
                                            component: EditPromo
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'wilayah',
                            name: 'Wilayah',
                            component: MasterWilayah
                        },
                        {
                            path: 'parameter',
                            name: 'Parameter',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterParameter
                                },
                            ]
                        },
                        {
                            path: 'akses-menu',
                            name: 'Akses Menu',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MasterAksesMenu
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'gadai',
                    name: 'Gadai',
                    redirect: '/gadai/daftar',
                    ...emptyPage,
                    children: [
                        {
                            path: 'daftar',
                            name: 'Daftar Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarGadai
                                },
                                {
                                    path: 'barang-hilang',
                                    name: 'Barang Hilang',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DaftarBarangHilang
                                        },
                                        {
                                            path: ':id',
                                            name: 'Detail Barang Hilang',
                                            component: DetailBarangHilang
                                        }
                                    ]
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Gadai',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailGadai
                                        },
                                        {
                                            path: "elektronik",
                                            name: "Edit",
                                            component: EditGadaiElektronik
                                        },
                                        {
                                            path: "kendaraan",
                                            name: "Edit",
                                            component: EditGadaiKendaraan
                                        },
                                        {
                                            path: "elek-staging",
                                            name: "Edit",
                                            component: EditStagingElektronik
                                        },
                                        {
                                            path: "kend-staging",
                                            name: "Edit",
                                            component: EditStagingKendaraan
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'pengajuan-gadai',
                            name: 'Pengajuan Gadai',
                            component: PengajuanGadai
                        },
                        {
                            path: 'elektronik',
                            name: 'Input Gadai Elektronik',
                            component: InputGadaiElektronik
                        },
                        {
                            path: 'kendaraan',
                            name: 'Input Gadai Kendaraan',
                            component: InputGadaiKendaraan
                        },
                        {
                            path: 'simulasi',
                            name: 'Simulasi Gadai',
                            component: SimulasiGadai
                        },
                        {
                            path: 'inquiry-faktur',
                            name: 'Pencarian Faktur',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: InquiryFaktur
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailInquiryFaktur
                                        },
                                        {
                                            path: "detail-history-gadai",
                                            name: "History Data Gadai",
                                            component: HistoryGadai
                                        },
                                        {
                                            path: "elektronik/:id",
                                            name: "Edit",
                                            component: EditGadaiElektronik
                                        },
                                        {
                                            path: "kendaraan/:id",
                                            name: "Edit",
                                            component: EditGadaiKendaraan
                                        },
                                        {
                                            path: "elek-staging/:id",
                                            name: "Edit",
                                            component: EditStagingElektronik
                                        },
                                        {
                                            path: "kend-staging/:id",
                                            name: "Edit",
                                            component: EditStagingKendaraan
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'pelunasan',
                            name: 'Pelunasan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: Pelunasan
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Pelunasan',
                                    component: DetailPelunasan
                                }
                            ]
                        },
                        {
                            path: 'perpanjangan',
                            name: 'Perpanjangan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: Perpanjangan
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Perpanjangan',
                                    component: DetailPerpanjangan
                                }
                            ]
                        },
                        {
                            path: 'daftar-penarikan',
                            name: 'Daftar Penarikan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarPenarikan
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Penarikan',
                                    component: DetailPenarikan
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'persetujuan',
                    name: 'Persetujuan',
                    redirect: '/persetujuan/cek-gadai',
                    ...emptyPage,
                    children: [
                        {
                            path: 'cek-gadai',
                            name: 'Cek Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: CekGadai
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailCekGadai
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'edit-gadai',
                            name: 'Edit Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: ApprovalEditGadai
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailApprovalEditGadai
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'keringanan',
                            name: 'Keringanan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: ApprovalKeringanan
                                },
                                {
                                    path: ':id/:noFaktur',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailKeringanan
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'void-pembayaran',
                            name: 'Void Pembayaran',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: VoidPembayaran
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailVoidPembayaran
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'kas-keluar',
                            name: 'Kas Keluar',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: ApprovalKasKeluar
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailApprovalKasKeluar
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'barang-hilang',
                            name: 'Barang Hilang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: ApprovalBarangHilang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailApprovalBarangHilang
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'pusat',
                    name: 'Pusat',
                    redirect: '/pusat/daftar-void-gadai',
                    ...emptyPage,
                    children: [
                        {
                            path: 'daftar-void-gadai',
                            name: 'Daftar Void Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarVoidGadai
                                },
                            ]
                        },
                        {
                            path: 'daftar-void-pembayaran',
                            name: 'Daftar Void Pembayaran',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarVoidPembayaran
                                },
                            ]
                        },
                        {
                            path: 'daftar-cek-gadai',
                            name: 'Daftar Cek Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarCekGadai
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailDaftarCekGadai
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'daftar-edit-gadai',
                            name: 'Daftar Edit Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarEditGadai
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailDaftarEditGadai
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'surat-bpkb',
                            name: 'Surat BPKB',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: SuratBpkb
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputSuratBpkb
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    component: DetailSuratBpkb
                                }
                            ]
                        },
                        {
                            path: 'daftar-penarikan',
                            name: 'Daftar Penarikan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarPenarikanPusat
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Penarikan',
                                    component: DetailPenarikanPusat
                                }
                            ]
                        },
                        {
                            path: 'sms',
                            name: 'SMS',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: SMS
                                },
                                {
                                    path: 'kirim',
                                    name: 'Kirim SMS',
                                    component: KirimSms
                                },
                            ]
                        },
                        {
                            path: 'monitoringip',
                            name: 'Monitoring IP',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: MonitoringIp
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    component: DetailMonitoringIp
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'kasir',
                    name: 'Kasir',
                    redirect: '/kasir/kas-mutasi',
                    ...emptyPage,
                    children: [
                        {
                            path: 'kas-mutasi',
                            name: 'Kas Mutasi',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: KasMutasi
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputKasMutasi
                                },
                                {
                                    path: 'inputho',
                                    name: 'Input',
                                    component: InputKasMutasiHo
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailKasMutasi
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'transaksi-gadai',
                            name: 'Transaksi Gadai',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: TransaksiGadai
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailTransaksiGadai
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'transaksi-kas-masuk',
                            name: 'Kas Masuk',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: KasMasuk
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputKasMasuk
                                },
                            ]
                        },
                        {
                            path: 'transaksi-kas-keluar',
                            name: 'Kas Keluar',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: KasKeluar
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputKasKeluar
                                },
                            ]
                        },
                        {
                            path: 'transaksi-pembayaran',
                            name: 'Transaksi Pembayaran',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: TransaksiPembayaran
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailTransaksiPembayaran
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'informasi-umum',
                    name: 'Informasi Umum',
                    ...emptyPage,
                    children: [
                        {
                            path: '',
                            component: InformasiUmum
                        },
                        {
                            path: 'input',
                            name: 'Input',
                            component: InputInformasiUmum
                        },
                        {
                            path: ':id',
                            name: 'Detail',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DetailInformasiUmum
                                },
                                {
                                    path: "edit",
                                    name: "Edit",
                                    component: EditInformasiUmum
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'lelang',
                    name: 'Lelang',
                    redirect: '/lelang/order-lelang',
                    ...emptyPage,
                    children: [
                        {
                            path: 'order-lelang',
                            name: 'Order Lelang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: BatchLelang
                                },
                                {
                                    path: 'input',
                                    name: 'Input',
                                    component: InputBatchLelang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    component: DetailBatchLelang
                                },
                                {
                                    path: ':id',
                                    name: 'Detail',
                                    ...emptyPage,
                                    children: [
                                        {
                                            path: '',
                                            component: DetailBatchLelang
                                        },
                                        {
                                            path: ':idBatch',
                                            name: 'Detail Batch Lelang',
                                            component: DetailBatchLelangItem
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'persiapan-lelang',
                            name: 'Persiapan Lelang',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: PersiapanLelang
                                },
                                {
                                    path: ':id',
                                    name: 'detail',
                                    component: DetailPersiapanLelang
                                }
                            ]
                        },
                        {
                            path: 'penjualan',
                            name: 'Penjualan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: PenjualanLelang
                                },
                                {
                                    path: 'bulk-set-jual-batal',
                                    name: 'Bulk Set Jual / Batal',
                                    component: BulkSetLelang
                                }
                            ]
                        },
                        {
                            path: 'kirim-balik',
                            name: 'Kirim Balik',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: KirimBalik
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'laporan',
                    name: 'Laporan',
                    redirect: '/laporan/laporan-stok-gudang',
                    ...emptyPage,
                    children: [
                        {
                            path: 'laporan-stok-gudang',
                            name: 'Stok Gudang',
                            component: StokGudang,
                        },
                        {
                            path: 'laporan-buku-besar',
                            name: 'Buku Besar',
                            component: BukuBesar,
                        },
                        {
                            path: 'laporan-kas-keluar',
                            name: 'Kas Keluar',
                            component: LaporanKasKeluar,
                        },
                        {
                            path: 'laporan-kas-masuk',
                            name: 'Kas Masuk',
                            component: LaporanKasMasuk,
                        },
                        {
                            path: 'laporan-kas-mutasi',
                            name: 'Kas Mutasi',
                            component: LaporanKasMutasi,
                        },
                        {
                            path: 'laporan-pembayaran',
                            name: 'Pembayaran',
                            component: LaporanPembayaran,
                        },
                        {
                            path: 'laporan-kas-cabang',
                            name: 'Kas Cabang',
                            component: LaporanKasCabang,
                        },
                        {
                            path: 'laporan-kembar-imei',
                            name: 'Kembar Imei',
                            component: LaporanKembarImei
                        },
                        {
                            path: 'laporan-pelunasan',
                            name: 'Pelunasan',
                            component: LaporanPelunasan,
                        },
                    ]
                },
                {
                    path: 'laporan-harian-cabang',
                    name: 'Laporan Harian Cabang',
                    redirect: '/laporan-harian-cabang/transaksi-harian',
                    ...emptyPage,
                    children: [
                        {
                            path: 'transaksi-harian',
                            name: 'Transaksi Harian',
                            component: TransaksiHarian,
                        },
                        {
                            path: 'serah-terima-gadai',
                            name: 'Serah Terima Gadai',
                            component: SerahTerimaGadai,
                        },
                        {
                            path: 'serah-terima-gadai-lunas',
                            name: 'Serah Terima Gadai Lunas',
                            component: SerahTerimaGadaiLunas,
                        },
                    ]
                },
                {
                    path: 'laporan-eksekutif',
                    name: 'Laporan Eksekutif',
                    redirect: '/laporan-eksekutif/laporan-gadai-baru',
                    ...emptyPage,
                    children: [
                        {
                            path: 'laporan-omzet',
                            name: 'Laporan Omzet',
                            component: LaporanOmzet
                        },
                        {
                            path: 'laporan-gadai-baru',
                            name: 'Laporan Gadai Baru',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: LaporanGadaiBaru,
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Laporan Gadai Baru',
                                    component: DetailLaporanGadaiBaru
                                }
                            ]
                        },
                        {
                            path: 'laporan-pemasukan',
                            name: 'Laporan Pemasukan',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: LaporanPemasukan,
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Laporan Pemasukan',
                                    component: DetailLaporanPemasukan
                                }
                            ]
                        },
                        {
                            path: 'laporan-pp-pl',
                            name: 'Laporan PP/ PL',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: LaporanPembayaranEksekutif,
                                },
                                {
                                    path: ':id',
                                    name: 'Detail Laporan PP/ PL',
                                    component: DetailLaporanPembayaranEksekutif
                                }
                            ]
                        },
                        {
                            path: 'daftar-bpkb-macet',
                            name: 'Daftar BPKB Macet',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarBpkbMacet,
                                },
                                {
                                    path: ':id',
                                    name: 'Detail BPKB Macet',
                                    component: DetailDaftarBpkbMacet
                                }
                            ]
                        },
                        {
                            path: 'daftar-gadai-aktif',
                            name: 'Daftar Gadai Aktif',
                            ...emptyPage,
                            children: [
                                {
                                    path: '',
                                    component: DaftarGadaiAktif,
                                },
                                {
                                    path: 'detail',
                                    name: 'Detail Gadai Aktif',
                                    component: DetailGadaiAktif
                                }
                            ]
                        },
                        {
                            path: 'laporan-penjualan',
                            name: 'Laporan Penjualan',
                            component: LaporanPenjualan,
                        },
                    ]
                },
                {
                    path: '/akses-laporan-eksekutif',
                    name: 'Akses Laporan Eksekutif',
                    component: AksesLaporanEksekutif,
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        }
    ]
}

let router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})

router.beforeEach((to, from, next) => {
    let currentTime = new Date().getTime()
    if (to.name !== 'login') {
        let token = localStorage.getItem('token')
        let rawExp = localStorage.getItem('exp')
        let exp = rawExp ? parseInt(rawExp, 10) : null

        // Convert seconds to milliseconds if timestamp is 10 digits
        if (exp && exp < 10000000000) {
            exp = exp * 1000
        }

        if (!token || !exp || currentTime > exp) {
            localStorage.clear()
            next({
                path: '/login'
            })
        } else {
            next()
        }
    }
    else {
        next()
    }
})

export default router
